import React, { Component } from 'react'
import {Grid} from 'semantic-ui-react';
import '../../assets/css/home.css';
import data from '../../assets/json/home/whychoose.json';
import headerBorder from '../../assets/images/line-orange.png';

class WhyChooseLMT extends Component {
	state = {
		data: data.whylmti
	};
	
	
  render() {
	var createReactClass = require('create-react-class');
		var ImagePreview = createReactClass({
			getInitialState() {
				return {
				  hover: false
				};
			},
			render: function(){
				return (
					<div>
						<img src={this.props.src} alt={this.props.alt} className="icn-why-choose"/>
						<h1 className="content-title">{this.props.title}</h1>
						<p className="para-content align-center">{this.props.caption}</p>
					</div>
				);
			}
		});
		
		
		return (
			<div>
				<Grid >
					<Grid.Column width={16} className="align-center">
						<h1 className="section-header">Why choose Light Miles Travel?</h1>
						<img src={headerBorder} className="header-border align-center" alt="" />
					</Grid.Column>	
				</Grid>
				<Grid className="why-choose-wrapper">
				{
					this.state.data.map((img,w) => (
						<Grid.Column width={4} className="align-center" key={img.id}>
							<ImagePreview
								src={img.photo}
								title={img.title}
								caption={img.caption}
								alt={img.alt}
							/>
						</Grid.Column>
					))
				}
				</Grid>
			</div>
        );
	}
}

export default WhyChooseLMT;